import { useEffect, useRef, useState } from "react";

const SR = typeof window !== "undefined" ? window.SpeechRecognition || window.webkitSpeechRecognition : null;
const MOBILE = /Android|iPhone|iPad|iPod/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
export const wakeSupported = !!SR && !MOBILE;
export const fold = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();

// Returns the text spoken after the assistant name, or null when the name was not said.
export function afterName(text, name) {
  const key = fold(name);
  if (!key) return null;
  const n = key.split(" ").length;
  const words = String(text || "").trim().split(/\s+/);
  const fw = words.map(fold);
  for (let i = 0; i + n <= fw.length; i++) if (fw.slice(i, i + n).join(" ") === key) return words.slice(i + n).join(" ").replace(/^[\s,.!?;:]+/, "");
  return null;
}

// Name activation with the browser speech recognizer (only while the page is open and the user enabled it).
export function useWakeWord(enabled, name, onWake) {
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [tries, setTries] = useState(0);
  const cb = useRef(onWake);
  cb.current = onWake;
  useEffect(() => {
    if (!enabled || !wakeSupported || !name) return undefined;
    let alive = true;
    let timer = null;
    const sr = new SR();
    sr.lang = "pt-BR"; sr.continuous = true; sr.interimResults = true;
    const fire = (rest) => {
      if (!alive) return;
      alive = false; clearTimeout(timer);
      try { sr.abort(); } catch { /* stopped */ }
      setActive(false); cb.current(rest);
    };
    sr.onresult = (e) => {
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const rest = afterName(e.results[i][0].transcript, name);
        if (rest === null) continue;
        clearTimeout(timer);
        if (e.results[i].isFinal) fire(rest); else timer = setTimeout(() => fire(rest), 1500);
      }
    };
    sr.onerror = (e) => { if (["not-allowed", "service-not-allowed", "audio-capture"].includes(e.error)) { alive = false; setActive(false); setError(e.error); } };
    sr.onend = () => { if (alive) try { sr.start(); } catch { /* restarting */ } };
    try { sr.start(); setActive(true); setError(""); } catch { setActive(false); }
    return () => { alive = false; clearTimeout(timer); try { sr.abort(); } catch { /* stopped */ } setActive(false); };
  }, [enabled, name, tries]);
  return { active, error, retry: () => setTries((t) => t + 1) };
}
